import { configureStore } from "@reduxjs/toolkit";

import { authReducer } from "./auth.slice";
import { usersReducer } from "./user.slice";
import { masterReducer } from "./master.slice";
import { registeredUserReducer } from "./registeredUser.slice";
import { facilityReducer } from "./facility.slice";
import { documentsReducer } from "./documents.slice";
import { dropdownReducer } from "./dropdownOptions.slice";
import { managementUserReducer } from "./managementUser.slice";
import { changePasswordReducer } from "./changePassword.slice";
import { PODReducer } from "./pod.slice";
import { lockDownReducer } from "./lockDown.slice";
import { paymentReportReducer } from "./paymentReport.slice";
import { kiosksReducer } from "./kiosks.slice";
import { postalMailReducer } from "./postalMail.slice";
import { connectionRequestReducer } from "./connectionRequest.slice";
import { textSearchReducer } from "./textSearch.slice";
import { DNDReducer } from "./dnd.slice";
import { maintenanceReducer } from "./maintenance.slice";
import { photoReducer } from "./photo.slice";
import { keywordReducer } from "./keyword.slice";
import { dashboardReducer } from "./dashboard.slice";
import { reportingReducer } from "./reporting.slice";
import { revenueReportingReducer } from "./revenueReport.slice";
import { noticeReducer } from "./notice.slice";
import { logReportReducer } from "./logReport.slice";
import { messagesReducer } from "./messages.slice";
import { IpActivityReducer } from "./ipActivity.slice";
import { staffRequestReducer } from "./staffRequest.slice";
import { inmateReducer } from "./inmate.slice";
import { publicUserReducer } from "./publicUser.slice";
import maintenanceMiddleware from "./middleware/maintenanceMiddleware";
import { eCardReducer } from "./ecard.slice";

export * from "./auth.slice";
export * from "./user.slice";
export * from "./master.slice";
export * from "./registeredUser.slice";
export * from "./facility.slice";
export * from "./documents.slice";
export * from "./dropdownOptions.slice";
export * from "./managementUser.slice";
export * from "./changePassword.slice";
export * from "./lockDown.slice";
export * from "./paymentReport.slice";
export * from "./kiosks.slice";
export * from "./postalMail.slice";
export * from "./connectionRequest.slice";
export * from "./dnd.slice";
export * from "./postalMail.slice";
export * from "./textSearch.slice";
export * from "./maintenance.slice";
export * from "./photo.slice";
export * from "./keyword.slice";
export * from "./dashboard.slice";
export * from "./reporting.slice";
export * from "./revenueReport.slice";
export * from "./notice.slice";
export * from "./logReport.slice";
export * from "./messages.slice";
export * from "./ipActivity.slice";
export * from "./staffRequest.slice";
export * from "./inmate.slice";
export * from "./publicUser.slice";
export * from "./ecard.slice";

export const store = configureStore({
  reducer: {
    users: usersReducer,
    auth: authReducer,
    master: masterReducer,
    registeredUser: registeredUserReducer,
    facility: facilityReducer,
    documents: documentsReducer,
    dropdownOptions: dropdownReducer,
    managementUser: managementUserReducer,
    changePassword: changePasswordReducer,
    pod: PODReducer,
    lockDown: lockDownReducer,
    paymentReport: paymentReportReducer,
    kiosks: kiosksReducer,
    postalMail: postalMailReducer,
    connectionRequest: connectionRequestReducer,
    textSearch: textSearchReducer,
    dnd: DNDReducer,
    maintenance: maintenanceReducer,
    photos: photoReducer,
    keyword: keywordReducer,
    dashboard: dashboardReducer,
    reporting: reportingReducer,
    revenueReporting: revenueReportingReducer,
    notice: noticeReducer,
    logReport: logReportReducer,
    messages: messagesReducer,
    ipActivity: IpActivityReducer,
    staffRequest: staffRequestReducer,
    inmate: inmateReducer,
    publicUser: publicUserReducer,
    ecard: eCardReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredPaths: ['auth.connectionData'],
        ignoredActions: ['auth/updateconnectionData'],
      },
    }).concat(maintenanceMiddleware),

  devTools: process.env.REACT_APP_API_ENV !== "production", // Enables DevTools only in development mode
});
